import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/AuthContext";
import { LanguageSwitcher } from "../LanguageSwitcher";

export function Header() {
  const { user, logout } = useAuth();
  const { t } = useTranslation();

  return (
    <header className="header">
      <div className="header-title">
        <h3>{t("admin.header.title")}</h3>
        <p className="muted">{t("admin.header.subtitle")}</p>
      </div>
      <div className="header-user">
        <LanguageSwitcher className="header-language" />
        <div className="user-info">
          <span className="user-label">{t("admin.header.greeting")}</span>
          <strong>{user?.name}</strong>
        </div>
        <button onClick={logout} className="btn-logout">{t("admin.header.logout")}</button>
      </div>
    </header>
  );
}
